export default [
    {
        path: '/gerar-ofertas',
        name: 'gerar-ofertas-index',
        component: () => import('./views/Index.vue'),
        meta: {
            title: 'Gerar Ofertas',
            icon: 'mdi-flash',
            breadcrumbs: [
                { text: 'Oferta', disabled: true, href: '/' },
                { text: 'Gerar Ofertas', disabled: true, href: '/' }
            ]
        }
    }
]
